import $ from 'cash-dom';
import debounce from 'lodash/debounce';

/*
 * Resize-start: debounce invoked on leading edge
 *
 */

$(window).on('resize', debounce(() => {
  $(window).trigger('resizestart');
}, 500, { leading: true, trailing: false }));

/*
 * Resize-stop: debounce invoked on trailing edge
 *
 */

$(window).on('resize', debounce(() => {
  $(window).trigger('resizestop');
}, 500));
